import type { ApolloError } from '@apollo/client';

import type { AnalyticsProfileSuggestionsProps } from 'src/modules/analytics/types';
import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';

import {
  type SuggestionsAction,
  Actions as SuggestionsActions,
} from './actions';

export const updateSuggestionsSuccess = (): SuggestionsAction => ({
  type: SuggestionsActions.SUGGESTIONS_UPDATE_SUCCESS,
});

export const updateSuggestionsFailure = (
  error: ApolloError,
): SuggestionsAction => ({
  type: SuggestionsActions.SUGGESTIONS_UPDATE_FAILURE,
  payload: error,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const PROFILE_SUGGESTIONS_LOADED = 'PROFILE_SUGGESTIONS_LOADED';
export const PROFILE_SUGGESTIONS_CTA_PRESSED =
  'PROFILE_SUGGESTIONS_CTA_PRESSED';

export const profileSuggestionsLoaded = (
  payload: AnalyticsProfileSuggestionsProps,
) => ({
  type: PROFILE_SUGGESTIONS_LOADED,
  payload,
});

export const profileSuggestionCTAPressed = (
  payload: AnalyticsProfileSuggestionsProps,
) => ({
  type: PROFILE_SUGGESTIONS_CTA_PRESSED,
  payload,
});
